import { render, staticRenderFns } from "./28.vue?vue&type=template&id=3e2a97b4&"
import script from "./28.vue?vue&type=script&lang=js&"
export * from "./28.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!/app/node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VRadio } from 'vuetify/lib'
import { VRadioGroup } from 'vuetify/lib'
installComponents(component, {VRadio,VRadioGroup})
